function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.35 10.291l-1.018 108.406 44.157-42.758 45.591 43.601 1.018-108.406-89.748-.843z",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5
});

function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 112 130",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTEyIDEzMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCI+CiAgPHBhdGggZD0iTTExLjM1IDEwLjI5MWwtMS4wMTggMTA4LjQwNiA0NC4xNTctNDIuNzU4IDQ1LjU5MSA0My42MDEgMS4wMTgtMTA4LjQwNi04OS43NDgtLjg0M3oiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjUiLz4KPC9zdmc+";
export { SvgBookmark as ReactComponent };